module.exports = __webpack_public_path__ + "img/banner_RSV_product_yd.5ea113bd.webp";